module.exports = __webpack_public_path__ + "img/hdcc.b4d1e1c2.png";